/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1PersonIdFinancialData202,
  PutApiV1PersonIdFinancialData400,
  PutApiV1PersonIdFinancialData401,
  PutApiV1PersonIdFinancialData404,
  PutApiV1PersonIdFinancialData500,
  PutApiV1PersonIdFinancialDataMutationRequest,
  PutApiV1PersonIdFinancialDataMutationResponse,
  PutApiV1PersonIdFinancialDataPathParams,
} from "../../types/personFinancialController/PutApiV1PersonIdFinancialData.ts";
import { personFinancialDataViewModelSchema } from "../personFinancialDataViewModelSchema.ts";
import { updateFinancialDataViewModelSchema } from "../updateFinancialDataViewModelSchema.ts";

export const putApiV1PersonIdFinancialDataPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1PersonIdFinancialDataPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1PersonIdFinancialData202Schema = z.lazy(
  () => personFinancialDataViewModelSchema,
) as unknown as ToZod<PutApiV1PersonIdFinancialData202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1PersonIdFinancialData400Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdFinancialData400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1PersonIdFinancialData401Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdFinancialData401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1PersonIdFinancialData404Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdFinancialData404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1PersonIdFinancialData500Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdFinancialData500>;

export const putApiV1PersonIdFinancialDataMutationRequestSchema = z.lazy(
  () => updateFinancialDataViewModelSchema,
) as unknown as ToZod<PutApiV1PersonIdFinancialDataMutationRequest>;

export const putApiV1PersonIdFinancialDataMutationResponseSchema = z.lazy(
  () => putApiV1PersonIdFinancialData202Schema,
) as unknown as ToZod<PutApiV1PersonIdFinancialDataMutationResponse>;
